import MyDesignsTable from './MyDesignsTable';

export default MyDesignsTable;
